import type { PageRow } from './pageRegistry'
import type { PaletteThread } from './paletteThreads'
import type { Activity, Contact } from 'app/generated/graphql'

export type PaletteRow =
  | { kind: `contact`; id: string; contact: Contact }
  | { kind: `activity`; id: string; activity: Activity }
  | { kind: `thread`; id: string; thread: PaletteThread }
  | { kind: `see-all-activities`; id: `see-all-activities`; query: string }
  | { kind: `page`; id: string; page: PageRow }
  | { kind: `create-contact`; id: `create-contact`; query: string }

/** Rows that Enter answers with a route. The create row opens a modal instead. */
export type NavigablePaletteRow = Exclude<PaletteRow, { kind: `create-contact` }>

/** cmdk needs one unique string per item; ids repeat across kinds, so prefix them. */
export function paletteRowValue(row: PaletteRow): string {
  return `${row.kind}:${row.id}`
}
